<!-- 翻转四边形 -->
<template>
  <div id="homeCard">
    <div class="card">
      <div
        @mouseenter="handleMouseEnter(item.id)"
        @mouseleave="handleMouseLeave(item.id)"
        class="card-item"
        v-for="item of list"
        :key="item.id"
      >
        <div class="content animated flipInY" v-show="item.flag">
          <h3 :class="languageTitle">{{ item.title }}</h3>
          <p :class="languageContent">{{ item.content }}</p>
        </div>
        <transition name="el-fade-in-linear">
          <div v-show="!item.flag" class="image">
            <img :src="item.src" alt="" />
            <h3 :class="languageTitle" class="zhengmian">
              {{ item.title }}
            </h3>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCard",
  data() {
    return {
      languageContent: "",
      languageTitle: "",
      list: [
        {
          id: 1,
          flag: false,
          // title: "优诊通",
          title: this.$t("lang.BetterMedicalCare.name"),
          src: require("../../assets/images/card/card1.jpg"),
          content: this.$t("lang.Home.BetterMedicalCare")
        },
        {
          id: 2,
          flag: false,
          title: this.$t("lang.InternationalReferral.name"),
          src: require("../../assets/images/card/card2.jpg"),
          content: this.$t("lang.Home.InternationalReferral")
        },
        {
          id: 3,
          flag: false,
          title: this.$t("lang.BetterHealthInsuranceCare"),
          src: require("../../assets/images/card/card3.jpg"),
          content: this.$t("lang.Home.BetterHealthInsuranceCare")
        },
        {
          id: 4,
          flag: false,
          title: this.$t("lang.LongDistanceMedicalConsultation"),
          src: require("../../assets/images/card/card4.jpg"),
          content: this.$t("lang.Home.LongDistanceMedicalConsultation")
        }
      ]
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    // if (this.$i18n.locale === "en-US") {
    //   let arr = document.getElementsByClassName("card-item-content");
    //   let titleBack = document.getElementsByClassName("title-back");
    //   let titleJust = document.getElementsByClassName("title-just");
    //   for (let i = 0; i < arr.length; i++) {
    //     arr[i].style.fontSize = "14px";
    //     arr[i].style.lineHeight = "16px";
    //     titleBack[i].style.fontSize = "16px";
    //     titleJust[i].style.fontSize = "16px";
    //   }
    // }
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.languageTitle = "card-item-title-us";
        this.languageContent = "card-item-content-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.languageTitle = "card-item-title";
        this.languageContent = "card-item-content";
      }
    },
    handleMouseEnter(id) {
      for (let i = 0; i < this.list.length; i++) {
        if (id === this.list[i].id) {
          this.list[i].flag = !this.list[i].flag;
        }
      }
    },
    handleMouseLeave(id) {
      for (let i = 0; i < this.list.length; i++) {
        if (id === this.list[i].id) {
          this.list[i].flag = !this.list[i].flag;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#homeCard {
  width: 75%;
  /*height: 338px;*/
  margin: 30px auto;
  display: flex;
  justify-content: center;
  .card {
    width: 100%;
    height: 100%;
    display: flex;
    .card-item {
      flex: 1;
      color: #ffffff;
      position: relative;
      margin-right: 20px;
      padding-bottom: 30%;
      .card-item-title {
        text-align: center;
        font-size: 24px;
        margin-top: 30px;
      }
      .card-item-title-us {
        text-align: center;
        font-size: 14px;
        margin-top: 30px;
      }
      .card-item-content {
        word-break: break-all;
        text-align: left;
        font-size: 16px;
        line-height: 20px;
        padding: 8px;
      }
      .card-item-content-us {
        word-break: break-all;
        text-align: left;
        font-size: 14px;
        line-height: 16px;
        padding: 8px;
      }
    }
  }
}
.image {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #ffffff;
  img {
    width: 100%;
    height: 100%;
    opacity: 1;
  }
  .zhengmian {
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 60px;
    bottom: 0;
    margin: auto;
  }
}
.content {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #ffffff;
  color: #9b9b9b;
  opacity: 0.8;
}
</style>
